/**
 * Build a `tel:` href from a stored phone string.
 *
 * tblaumembers.Phone is free text. Production holds "773-627-2673",
 * "(773) 627-2673" and "773.627.2673" in the same column, so the digits are
 * extracted rather than pasted into the href.
 *
 * Returns '' when there is no digit to dial. A caller that gets '' must render
 * the number as plain text: a `tel:` link with nothing to dial is a dead link
 * that still looks tappable on a phone.
 */
export function telHref(phone: string | null | undefined): string {
  const trimmed = (phone ?? '').trim()
  if (trimmed === '') return ''
  const plus = trimmed.startsWith('+') ? '+' : ''
  const digits = trimmed.replace(/\D/g, '')
  return digits === '' ? '' : `tel:${plus}${digits}`
}
